import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { Typography } from '@percent/lemonade'
import { ReactComponent as CompleteIcon } from '@percent/product-nomination-form/assets/icons/complete.svg'
import { Card } from '@percent/product-nomination-form/ui'

import { usePartnerConfig } from '@percent/product-nomination-form/hooks'
import { useEffect } from 'react'
import { useValidationStepData } from '../../validationStepContext/useValidationStepData/useValidationStepData'
import styles from './Complete.module.scss'

export const Complete = () => {
  const { t } = useTranslation()
  const { partnerConfig } = usePartnerConfig()
  const { organisation } = useValidationStepData()

  const { getValues } = useFormContext()
  const validationRequestName = getValues('organisationName')

  useEffect(() => {
    if (partnerConfig?.redirectUrl) {
      setTimeout(() => {
        window.location.href = partnerConfig.redirectUrl
      }, 5000)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Card>
      <CompleteIcon className={styles.completeIcon} />
      <Typography variant="h2" className={styles.title}>
        {t('hostedValidation.complete.thanksForApplication')}
      </Typography>
      <Typography variant="large" className={styles.description}>
        {t('hostedValidation.complete.description', {
          organisationName: organisation?.name ?? validationRequestName,
          interpolation: { escapeValue: false },
        })}
      </Typography>
    </Card>
  )
}
